module.exports = __webpack_public_path__ + "static/koala-red-53c0736377bd92d3b625f93016b70b5b.png";